<div class="list-page kapea tositteet-listaus-page" [class.dragging]="isDragging()" style="padding: 0">
  <form novalidate class="ylaosan-kontrollit">
    <div class="lisaa-nappula-container">
      <button mat-button (click)="naytaTiedostonValintaDialogi()" type="button" class="primarybutton mat-elevation-z4">
        <i class="icon ion-ios-cloud-upload mat-icon"></i>
        {{ 'tositteet.myynti.listaus.lisaa' | translate | async }}
      </button>
    </div>

    <div class="hakukontrollit">
      <mat-form-field>
        <mat-icon matPrefix class="listaus-haku-ikoni">search</mat-icon>
        <mat-label>{{ 'kuitit.etsi' | translate | async }}</mat-label>
        <input type="text" [formField]="lomake.nimiFirestore" matInput />
      </mat-form-field>
    </div>
  </form>

  @if (kuvavirheAvain()) {
    <div class="red-text" style="text-align: center; padding-left: 10vw; padding-right: 10vw">{{ kuvavirheAvain() | translate: kuvavirheParametrit() | async }}</div>
  }

  <div style="padding-top: 20px">
    @if (!etsitaan()) {
      <div>
        <table style="margin-left: auto; margin-right: auto">
          <tr>
            <td>
              <button mat-icon-button (click)="edellinenKuukausi()" class="dark-gray-text large-icon-button" style="padding-right: 10px">
                <i class="icon ion-ios-arrow-back mat-icon"></i>
              </button>
            </td>
            <td style="font-size: 28px; line-height: 34px; text-align: center" class="light-blue-text">
              {{ otsikkoObservable | async }}
            </td>
            <td>
              <button mat-icon-button (click)="seuraavaKuukausi()" class="dark-gray-text large-icon-button" style="padding-left: 10px">
                <i class="icon ion-ios-arrow-forward mat-icon"></i>
              </button>
            </td>
          </tr>
        </table>
        <div class="kuukausi-summa dark-gray-text">
          {{ annaKuittienSummaKuukaudelle() | lmoney: 'EUR' | async }}
        </div>
      </div>
    }

    @if (showSelvitettavatAndMainMaksutapaObservable | async) {
      <div style="display: flex; width: 100%; flex-flow: row wrap; align-items: top; justify-content: center; padding-top: 25px">
        <!-- <app-selvitettavat-maksutapa style="margin: 20px; align-self: flex-start" [insertValues]="selvitettavienTiedotObservable | async" [selvitettavatValittu]="selvitettavatValittuObservable | async" (valitsiSelvitettavat)="selvitettavatValittu()"> </app-selvitettavat-maksutapa> -->
        @if (maksutapaJaKuvaObservable | async; as maksutapaJaKuva) {
          <app-file-drop #droppi dropZoneClassName="maksutapa-container" [class.valittu-maksutapa]="maksutapaJaKuva.valittu && !isDragging()" (click)="valitseMainMaksutapa()" (onFileOver)="fileOver($event, maksutapaJaKuva)" (onFileDrop)="fileDrop($event)" (onFileLeave)="fileLeave($event, maksutapaJaKuva)" class="droppi">
            <ng-template app-file-drop-content-tmp>
              <div class="maksutapa-laatikko" [class.lemon-mat-elevation-z4]="!isDragging()">
                @if (!isDragging()) {
                  <div class="kuittien-maara-maksutavalle" [class.light-gray-text]="!maksutapaJaKuva.valittu" [class.light-blue-text]="maksutapaJaKuva.valittu">
                    {{ maksutapaJaKuva.lukumaara }}
                  </div>
                }
                <img [src]="maksutapaJaKuva.kuva | async" [class.light-gray-background]="(!maksutapaJaKuva.valittu && !isDragging()) || (!droppi.isDraggingOverDropZone && isDragging())" [class.light-blue-background]="(maksutapaJaKuva.valittu && !isDragging()) || (droppi.isDraggingOverDropZone && isDragging())" />
                <div class="maksutavan-nimi-container" [class.light-gray-text]="(!maksutapaJaKuva.valittu && !isDragging()) || (!droppi.isDraggingOverDropZone && isDragging())" [class.light-blue-text]="(maksutapaJaKuva.valittu && !isDragging()) || (droppi.isDraggingOverDropZone && isDragging())">
                  <span style="display: inline-block; vertical-align: middle">
                    {{ maksutapaJaKuva.maksutapa.l }}
                  </span>
                </div>
              </div>
              @if (!isDragging()) {
                <div class="maksutapa-summa" [class.light-gray-text]="!maksutapaJaKuva.valittu" [class.light-blue-text]="maksutapaJaKuva.valittu">
                  {{ maksutapaJaKuva.summa | lmoney: 'EUR' | async }}
                </div>
              }
              @if (isDragging()) {
                <div class="veda-tanne light-blue-text">
                  {{ 'kuitit.veda-tanne' | translate | async }}
                </div>
              }
            </ng-template>
          </app-file-drop>
        }
      </div>
    }

    @if (isDragging() && !(showSelvitettavatAndMainMaksutapaObservable | async)) {
      <div style="margin-top: 40px">
        <app-file-drop #droppi dropZoneClassName="drag-container" (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)" (onFileDrop)="fileDrop($event)" class="droppi">
          <ng-template app-file-drop-content-tmp>
            <div class="drag-laatikko" [style.background-color]="droppi.isDraggingOverDropZone && isDragging() ? 'lightgray' : 'white'">
              <div>{{ 'tositteet.myynti.listaus.rahaa-tanne' | translate | async }}</div>
              <!-- <img src="/assets/nuoli_alas.png" style="background-color: inherit" /> -->
            </div>
          </ng-template>
        </app-file-drop>
      </div>
    }

    <!-- @if ((showSelvitettavatAndMainMaksutapaObservable | async) && (selvitettavatValittuObservable | async)) {
      <app-selvitettavat-tositteet [showLoading]="false"></app-selvitettavat-tositteet>
    } -->
  </div>

  @if (!(showSelvitettavatAndMainMaksutapaObservable | async) || !(selvitettavatValittuObservable | async)) {
    <div>
      <div class="kortti-container">
        @for (kuitti of naytettavatKuititObservable | async; track trackKuitti($index, kuitti)) {
          <div class="kuitti-laatikko lemon-mat-elevation-z4" (click)="katsele(kuitti)">
            @if (vihreaPilvi(kuitti)) {
              <mat-icon style="position: absolute; right: 5px; top: 5px" class="green-text">cloud_done</mat-icon>
            } @else {
              <mat-icon style="position: absolute; right: 8px; top: 5px" class="yellow-text flashit">cloud_upload</mat-icon>
            }
            <div app-tosite-kuva [url]="kuitti.ensimmainenKuva" class="kuva-container" [thumbnail]="true"></div>
            <div class="tiedot-container">
              <div class="pvm dark-gray-text">{{ kuitti.localPvm | lokaalipvm | async }}</div>
              <div class="summa light-blue-text">{{ kuitti.sum ?? kuitti.summa | lmoney: 'EUR' | async }}</div>
              <div class="viiva light-gray-background"></div>
              <div class="selite dark-gray-text">{{ kuitti.selite }}</div>
            </div>
          </div>
        }
      </div>
      @if (naytaEiYhtaanObservable | async) {
        <div class="table-ladataan" style="position: relative; top: 0px; width: 100%; height: 100%; display: flex; justify-items: center; align-items: center">
          <div class="dark-gray-text" style="width: 100%; padding-top: 50px; text-align: center; margin: 10px 40px">
            {{ 'tositteet.myynti.listaus.ei-tositteita' | translate | async }}
          </div>
        </div>
      }
      @if (lataaObservable | async) {
        <div class="table-ladataan" style="position: relative; top: 0px; width: 100%; height: 100%; display: flex; justify-items: center; align-items: center">
          <div class="dark-gray-text" style="width: 100%; padding-top: 50px; text-align: center; margin: 10px 40px; position: relative">
            <div lemon-loading [show]="true"></div>
          </div>
        </div>
      }
    </div>
  }
</div>

<input style="visibility: hidden; height: 1px" (change)="fileChanged($event)" type="file" #fileInput multiple="multiple" />
<!-- accept="image/*,application/pdf" -->
